export default __webpack_public_path__ + "static/media/strokeCross.f6d863f6.svg";